import { mapGetters, mapState } from "vuex"

import nav_dash_menu from "~/components/nav/loggedIn/dashMenu"
import width_expand from "~/components/transitions/widthExpand"
import nav_context_menu from "~/components/nav/loggedIn/contextMenu"
import notification_space from "~/components/nav/navigation/notificationSpace"

import events_mixin from "@/mixins/events"

export default {
  components: {
    width_expand,
    nav_dash_menu,
    nav_context_menu,
    notification_space,
  },
  mixins: [events_mixin],
  data: function () {
    return {
      displayContextMenu: false,
      displayDashMenu: false,
    }
  },
  methods: {
    emitDraftStart: function () {
      this.trackEvent({
        category: "Campaign",
        action: "Start",
        method: "Navigation",
        balance: this.GROOVIZ,
        firstPaymentDate: this.FIRST_PAYMENT_DATE,
      })
    },
    toggle_dash_menu: function () {
      this.displayDashMenu = !this.displayDashMenu
    },
    close_dash_menu: function () {
      this.displayDashMenu = false
    },
    toggle_context_menu: function () {
      this.displayContextMenu = !this.displayContextMenu
    },
    close_context_menu: function () {
      this.displayContextMenu = false
    },
  },
  computed: {
    name: function () {
      let name = this.IS_BAND ? this.BAND_DATA?.name : this.INF_NAME

      return name?.length > 15 ? name.substring(0, 15).concat("", "...") : name
    },
    chevron_context: function () {
      return this.displayContextMenu ? "up" : "down"
    },
    chevron_feedback: function () {
      return this.displayDashMenu ? "up" : "down"
    },
    picture: function () {
      if (this.IS_BAND) return `${this.BAND_PICTURE}?ts=${new Date().getTime()}`
      else
        return `${this.INF_PICTURE({
          size: "40_40",
        })}?ts=${new Date().getTime()}`
    },
    dashboard_url: function () {
      return `/${this.USER_KIND}/dashboard/`
    },
    ...mapGetters({
      IS_BAND: "user/IS_BAND",
      BAND_PICTURE: "user/band/GET_PICTURE",
      INF_PICTURE: "user/influencer/GET_PICTURE",
      IS_INF: "user/IS_INF",
      USER_KIND: "user/KIND",
      BAND_DATA: "user/band/BAND_DATA",
    }),
    ...mapState({
      FIRST_PAYMENT_DATE: (state) => state.user.first_payment_date,
      GROOVIZ: (state) => state.user.grooviz,
      BAND_ID: (state) => state.user.band.id,
      INF_NAME: (state) => state.user.influencer.entity,
    }),
  },
}
